import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class conditionQuery{
  equalQueryCondition(query, filterOption) {
    query.equalTo(filterOption.field, filterOption.value);
  }

  notEqualQueryCondition(query, filterOption) {
    query.notEqualTo(filterOption.field, filterOption.value);
  }

  greaterThanQueryCondition(query, filterOption) {
    query.greaterThan(filterOption.field, filterOption.value);
  }

  lessThanQueryCondition(query, filterOption) {
    query.lessThan(filterOption.field, filterOption.value);
  }

  lessThanOrEqualToQueryCondition(query, filterOption) {
    query.lessThanOrEqualTo(filterOption.field, filterOption.value);
  }
  
  greaterThanOrEqualToQueryCondition(query, filterOption) {
    query.greaterThanOrEqualTo(filterOption.field, filterOption.value);
  }

  containedInQueryCondition(query, filterOption) {
    query.containedIn(filterOption.field, filterOption.value);
  }
  
  notContainedInQueryCondition(query, filterOption) {  // send value as array
    query.notContainedIn(filterOption.field, filterOption.value);
  }

  
}